import { BaseModel } from '../classes/base-model';

export class Generic extends BaseModel{

}



// WEBPACK FOOTER //
// ./src/app/models/generic.ts